import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo, navigation, writings } from '../data/mock';
import { 
  Home, 
  ChevronDown, 
  ChevronRight,
  Pencil, 
  Camera, 
  FolderOpen, 
  Clapperboard,
  Monitor, 
  Plane,
  Menu,
  X
} from 'lucide-react';

const iconMap = {
  Pencil: Pencil,
  Camera: Camera,
  FolderOpen: FolderOpen,
  Clapperboard: Clapperboard,
  Monitor: Monitor,
  Plane: Plane,
};

const Sidebar = () => {
  const location = useLocation();
  const [craftOpen, setCraftOpen] = useState(false);
  const [listsOpen, setListsOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const NavItem = ({ item }) => {
    const IconComponent = iconMap[item.icon];
    const active = isActive(item.path);
    
    return (
      <Link
        to={item.path}
        onClick={() => setMobileOpen(false)}
        className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
          active 
            ? 'bg-[#1c1c1f] text-[#f5f5f5]' 
            : 'text-[#a1a1aa] hover:bg-[#151518] hover:text-white'
        }`}
      >
        {IconComponent && <IconComponent size={18} className="flex-shrink-0" />}
        <span className="flex-1">{item.name}</span>
        {item.count && (
          <span className="text-xs text-[#7a7a86] bg-[#1f1f23] px-2 py-0.5 rounded">
            {item.count}
          </span>
        )}
      </Link>
    );
  };

  const SidebarContent = () => (
    <>
      {/* Profile Section */}
      <div className="p-4 border-b border-[#1f1f23]">
        <Link to="/" className="flex items-center gap-3" onClick={() => setMobileOpen(false)}>
          <img 
            src={siteInfo.avatar} 
            alt={siteInfo.name}
            className="w-8 h-8 rounded-full object-cover"
          />
          <span className="font-medium text-white">{siteInfo.name}</span>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="p-3 flex-1 overflow-y-auto">
        {/* Home */}
        <Link
          to="/"
          onClick={() => setMobileOpen(false)}
          className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors mb-2 ${
            isActive('/') && location.pathname === '/'
              ? 'bg-[#1c1c1f] text-[#f5f5f5]' 
              : 'text-[#a1a1aa] hover:bg-[#151518] hover:text-white'
          }`}
        >
          <Home size={18} />
          <span>Home</span>
        </Link>

        {/* Projects */}
        <Link
          to="/projects"
          onClick={() => setMobileOpen(false)}
          className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors mb-2 ${
            isActive('/projects')
              ? 'bg-[#1c1c1f] text-[#f5f5f5]'
              : 'text-[#a1a1aa] hover:bg-[#151518] hover:text-white'
          }`}
        >
          <FolderOpen size={18} />
          <span>Projects</span>
        </Link>

        {false && craftOpen && (
          <div className="mt-1 space-y-0.5">
            {/* {navigation.craft.map((item) => (
              <NavItem key={item.path} item={item} />
            ))} */}
          </div>
        )}

        {/* Lists Section */}
        <div className="mt-4">
          <button
            onClick={() => setListsOpen(!listsOpen)}
            className="flex items-center gap-2 px-3 py-1 text-xs font-medium text-[#7a7a86] uppercase tracking-wider w-full hover:text-[#c5c5d0] transition-colors"
          >
            {listsOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
            Lists
          </button>
          {listsOpen && (
            <div className="mt-1 space-y-0.5">
              {navigation.lists.map((item) => (
                <NavItem key={item.path} item={item} />
              ))}
            </div>
          )}
        </div>
      </nav>
    </>
  );

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setMobileOpen(true)}
        className="lg:hidden fixed top-4 left-4 z-40 p-2 bg-[#111112] text-white rounded-lg shadow-md border border-[#1f1f23]"
      >
        <Menu size={20} />
      </button>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex flex-col w-56 bg-[#0d0d0f] border-r border-[#1f1f23] h-screen sticky top-0">
        <SidebarContent />
      </aside>

      {/* Mobile Sidebar */}
      <aside className={`lg:hidden fixed left-0 top-0 h-full w-64 bg-[#0d0d0f] border-r border-[#1f1f23] z-50 transform transition-transform duration-300 ${
        mobileOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <button
          onClick={() => setMobileOpen(false)}
          className="absolute top-4 right-4 p-1 text-[#a1a1aa] hover:text-white"
        >
          <X size={20} />
        </button>
        <SidebarContent />
      </aside>
    </>
  );
};

export default Sidebar;
